<div class="flex flex-col gap-4">
    <div class="card flex flex-col gap-4 max-w-xl">
        <div class="flex items-center justify-between gap-3">
            <div class="font-semibold text-xl">Active Payment Method</div>
            @if (methodDirty()) {
                <p-tag severity="warn" value="edited" [rounded]="true" />
            }
        </div>

        <div>
            <p-select
                class="w-full"
                [ngModel]="paymentMethodDraft()"
                (ngModelChange)="setMethod($event)"
                [options]="paymentMethodOptions()"
                optionLabel="label"
                optionValue="value"
                optionDisabled="disabled"
                appendTo="body"
            >
                <ng-template let-option #item>
                    <div class="flex flex-col gap-0.5">
                        <span [class.text-muted-color]="option.disabled">{{ option.label }}</span>
                        @if (option.hint) {
                            <small class="text-muted-color">{{ option.hint }}</small>
                        }
                    </div>
                </ng-template>
            </p-select>
            <small class="text-muted-color">
                Determines which provider this website uses to take deposits. Switch is rejected by the backend if the chosen provider is not configured.
            </small>
        </div>
    </div>

    <p-tabs [value]="initialSubtab()">
        <p-tablist>
            <p-tab value="stripe">
                <span class="flex items-center gap-2">
                    <i class="pi pi-stripe"></i>
                    Stripe
                    <i
                        [class]="stripeReady() ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-muted-color'"
                        style="font-size: 0.9rem"
                        [pTooltip]="stripeReady() ? 'Stripe is enabled on the parent company' : 'Stripe is not configured on the parent company'"
                    ></i>
                </span>
            </p-tab>
            <p-tab value="finera">
                <span class="flex items-center gap-2">
                    <i class="pi pi-credit-card"></i>
                    Finera
                    <i
                        [class]="fineraReady() ? 'pi pi-check-circle text-green-500' : 'pi pi-circle text-muted-color'"
                        style="font-size: 0.9rem"
                        [pTooltip]="fineraReady() ? 'Finera is enabled' : 'Finera is not enabled'"
                    ></i>
                </span>
            </p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="stripe">
                <app-website-info-stripe [company]="company()" />
            </p-tabpanel>
            <p-tabpanel value="finera">
                <app-website-info-finera [realm]="realm()" [(draft)]="fineraDraft" [(withdrawDraft)]="fineraWithdrawDraft" />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>
